import { useState, useEffect } from "react";
import "../AllNotes.css";
import "../VerifyAccount.css";
import { withRouter } from "react-router";
import RecordingNoteCont from "../container/RecordingNoteCont";
import useDebounce from "../../../shared/components/customHooks/useDebounce";
import { showSwalPopup } from "../actions/ShowSwalPopup";
import { stopRecordingMain, toggleRecordingMain } from "../../../redux/actions/note.action";
import ModalPopup from "../../../components/newcomponents/ModalPopup";
import DenyPermissionComp from "../../patientProfile/component/denyPermissionComp/denyPermissionComp";
import EpicTemplateCont from "../../epic/container/EpicTemplateCont";

const NotesComp = (props) => {
   const {
      notesContent,
      createNotes = () => {},
      GetNotes = () => {},
      noteId,
      updateNotesTemp = () => {},
      setnotesContent,
      history,
      deleteNotes,
      setStartPolling,
      startPolling,
      uploadMediaV2 = () => {},
      UpdatesNoteStatus = () => {},
      setNoteId = () => {},
      patientDetails,
      setShowButton,
      stopRecordingMainEpic,
      isVimProvider,
      isDemo = false,
      intitalDemoDone = false,
      setInitialDemo,
   } = props;
   const [isRecording, setIsRecording] = useState(false);
   const [showComponent, setShowComponent] = useState(false);
   const [showTemplateSelectionComp, setShowTemplateSelectionComp] = useState(false);
   const [mediaId, setMediaId] = useState("");
   const [isStartRecording, setIsStartRecording] = useState(true);
   const [searchKey, setSearchKey] = useState("");
   const [statusPending, setStatusPending] = useState(false);
   const [editComponent, setEditComponent] = useState(false);
   const [showPermissionModal, setShowPermissionModal] = useState(false);
   const [showBanner, setShowBanner] = useState(true);
   const [initialTime, setInitialTime] = useState("");

   useEffect(() => {
      const searchParams = new URLSearchParams(props.location.search);
      const isStartRecording = searchParams.get("startrecording") === "true" ? true : false;
      if (isStartRecording) {
         props.history.push("/notes?startrecording=true");
         setShowComponent(false);
         setIsStartRecording(false);
         toggleRecordingMain();
         let generateNote = {
            description: "",
            isConvert: true,
            location: "" || `mpeg`,
            title: "" || `mpeg`,
            type: "audio/mpeg",
         };
         createNotes(generateNote, "");
      }
      handleClick();
   }, []);

   const handleClick = (createNote = true) => {
      const doc = localStorage.getItem("draftContinue") || false;

      setIsStartRecording(false);
      // history.push(`/notes/?startrecording=true`);
      if (createNote && !doc) {
         let generateNote = {
            description: "",
            isConvert: true,
            location: "" || `mpeg`,
            title: "" || `mpeg`,
            type: "audio/mpeg",
         };
         createNotes(generateNote, "");
      } else {
         const noteIdDraft = localStorage.getItem("noteIdCurrent");
         setNoteId(noteIdDraft);
         const timeForNote = localStorage.getItem(noteIdDraft);
         setInitialTime(timeForNote);
      }
      localStorage.removeItem("draftContinue");

      toggleRecordingMain();
   };

   const removeRecordingFromUrl = () => {
      // history.push(`/notes/`);
   };

   const debounceSearch = useDebounce(searchKey, 500);

   useEffect(() => {
      GetNotes(debounceSearch, () => {}, true);
   }, [debounceSearch]);

   return (
      <div className="notes-contener">
         <div className={`w-100 h-100 ${!showTemplateSelectionComp && "record-container"} `}>
            <div
               className={` ${
                  isVimProvider ? "m-t-9" : !isStartRecording && showBanner && "adjust-margin-top-recording"
               } ${!isStartRecording ? "  m-5 " : "w-100 h-100 "}`}
            >
               <div className="w-100 d-flex align-items-center justify-content-center">
                  {showTemplateSelectionComp ? (
                     <EpicTemplateCont
                        setNotePending={() => {
                           UpdatesNoteStatus(noteId);
                        }}
                        handleRadioChange={(id) => {
                           updateNotesTemp({ id: noteId, templateId: id });
                        }}
                     />
                  ) : (
                     <RecordingNoteCont
                        setInitialDemo={setInitialDemo}
                        intitalDemoDone={intitalDemoDone}
                        isDemo={isDemo}
                        isVimProvider={isVimProvider}
                        patientDetails={patientDetails}
                        setInitialTime={setInitialTime}
                        initialTime={initialTime}
                        uploadMediaV2={uploadMediaV2}
                        showBanner={showBanner}
                        createNotes={createNotes}
                        isRecording={isRecording}
                        setIsRecording={setIsRecording}
                        setShowComponent={setShowComponent}
                        GetNotes={GetNotes}
                        setIsStartRecording={setIsStartRecording}
                        noteId={noteId}
                        removeRecordingFromUrl={removeRecordingFromUrl}
                        discardRecording={() => {
                           if (isVimProvider) {
                              localStorage.setItem("saveRecord", "false");
                              setIsStartRecording(true);
                              // removeRecordingFromUrl();
                              stopRecordingMain();
                              // GetNotes("", () => {}, true);
                              stopRecordingMainEpic();
                              return;
                           }
                           showSwalPopup(
                              "Save or Delete Draft?",
                              "Delete note or save as draft? ",
                              "",
                              "Save as Draft",
                              "Delete",
                              () => {
                                 localStorage.setItem("saveRecord", "false");
                                 setIsStartRecording(true);
                                 // removeRecordingFromUrl();
                                 stopRecordingMain();
                                 // GetNotes("", () => {}, true);
                                 stopRecordingMainEpic();
                              },
                              () => {
                                 const currentNoteID = localStorage.getItem("noteIdCurrent");
                                 if (currentNoteID) {
                                    deleteNotes(currentNoteID, false);
                                    localStorage.setItem("saveRecord", "false");
                                    setIsStartRecording(true);
                                    // removeRecordingFromUrl();
                                    stopRecordingMain();
                                    stopRecordingMainEpic(false);
                                 }
                              },
                              true,
                              false
                           );
                        }}
                        onSave={(media) => {
                           if (isVimProvider) {
                              props.stopRecordingMainEpic();
                              return;
                           }
                           stopRecordingMain();
                           setShowComponent(true);
                           setShowTemplateSelectionComp(true);
                           setShowButton(true);
                        }}
                        onPermissionNotAllowed={() => {
                           const currentNoteID = localStorage.getItem("noteIdCurrent");
                           if (currentNoteID) {
                              deleteNotes(currentNoteID, false);
                              localStorage.setItem("saveRecord", "false");
                              setIsStartRecording(true);
                              removeRecordingFromUrl();
                              stopRecordingMain();
                           }
                        }}
                        onNoteCompleted={() => {
                           stopRecordingMain();
                           // setShowComponent(true);
                        }}
                     />
                  )}
               </div>
            </div>

            {showPermissionModal && (
               <ModalPopup>
                  <DenyPermissionComp closeModal={() => setShowPermissionModal(false)} />
               </ModalPopup>
            )}
         </div>
      </div>
   );
};

export default withRouter(NotesComp);
